import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FaHome,
  FaUserMd,
  FaNotesMedical,
  FaChartBar,
  FaUser,
  FaMapMarkedAlt,
  FaHeadset,
  FaSignOutAlt,
  FaBars, // icon burger
  FaTimes,
  FaQuestion, // icon close
} from "react-icons/fa";
import "../CSS/SidebarTenagaKesehatan.css";

function SidebarAdmin() {
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();

  const isActive = (...paths) => {
    return paths.some((path) => location.pathname.startsWith(path));
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Tombol burger */}
      <div className="hamburger" onClick={toggleSidebar}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="logo-section">
          <img
            src="/assets/logobaruTibiSmart.png"
            alt="TibiSmart Logo"
            className="logo"
          />
        </div>

        <ul className="menusidebar">
          <li>
            <NavLink to="/" activeclassname="active">
              <FaHome /> Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/HalamanRingkasanAnalitikAdmin" activeclassname="active">
              <FaChartBar /> Analitik
            </NavLink>
          </li>
          <li>
            <NavLink to="/HalamanDataPasienAdmin" activeclassname="active">
              <FaNotesMedical /> Screening
            </NavLink>
          </li>
          <li>
            <NavLink to="/HalamanPetaRisikoAdmin" activeclassname="active">
              <FaMapMarkedAlt /> Peta Resiko
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/HalamanTenagaKesehatan"
              className={() =>
                location.pathname.startsWith("/HalamanTenagaKesehatan") ||
                  location.pathname.startsWith("/HalamanDetailTenagaKesehatan")
                  ? "active"
                  : ""
              }
            >
              <FaUserMd /> Kelola Radiolog
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/HalamanDokterParu"
              className={() =>
                location.pathname.startsWith("/HalamanDokterParu") ||
                  location.pathname.startsWith("/HalamanDetailDokterParu")
                  ? "active"
                  : ""
              }
            >
              <FaUserMd /> Kelola Dokter Paru
            </NavLink>
          </li>
          <li>
            <NavLink to="/HalamanKelolaFAQsAdmin" activeclassname="active">
              <FaQuestion /> Kelola FAQ
            </NavLink>
          </li>
        </ul>

        <div className="bottom-menu">
          <li>
            <NavLink to="/HalamanProfileAdmin" activeclassname="active">
              <FaUser /> Profile
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/HalamanLaporanKendalaTeknisAdmin"
              className={() =>
                isActive(
                  "/HalamanLaporanKendalaTeknisAdmin",
                  "/HalamanTindakLanjut"
                )
                  ? "active"
                  : ""
              }
            >
              <FaHeadset /> Support
            </NavLink>
          </li>
          <li>
            <NavLink to="/loginadmin" activeclassname="active">
              <FaSignOutAlt /> Log Out
            </NavLink>
          </li>
        </div>
      </div>

      {/* Overlay background saat sidebar terbuka di mobile */}
      {isOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </>
  );
}

export default SidebarAdmin;
